import {Typography} from 'antd';

const { Text } = Typography;
export default Text;